import { adminHttpClient } from "../../../../commons/adminHttpClinet";

const deleteMarketplace = (id:string): Promise<any> => {
    return adminHttpClient.delete(`/api/Admin/AdminMarketplace/delete-marketplace?Id=${id}`, null)
}
export default deleteMarketplace;

